import classNames from "classnames";

import style from "./Badge.module.css"; // eslint-disable-line

export const Badge: React.FC<{
  children: React.ReactNode;
  variant: "primary" | "grayscale" | "error";
  radius?: "none" | "large" | "full";
  className?: string;
}> = ({ children, variant = "primary", radius = "large", className, ...args }) => {
  return (
    <div className={classNames(style.badge, style[variant], style[radius], className)} {...args}>
      {children}
    </div>
  );
};
